module.exports = __webpack_public_path__ + "media/images/emblems/Senarclens-coat_of_arms-112c8f90ee5f00ecbe44eb4b5682b415.svg";